var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{staticClass:"additional-service"},_vm._l((_vm.content),function(list){return _c('AdditionalServiceListSection',{key:list.id,attrs:{"list":list},on:{"popupShow":_vm._popupShowHandler}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }